export default {
  placeholder: 'Cerca',
  cancel: 'Annulla',
};
